import { AttachmentModule } from '../attachment/attachment.module';

/**
 * Moduł załączników ustawienia
 *
 * @export
 * @class SettingAttachmentModule
 * @extends {AttachmentModule}
 */
export class SettingAttachmentModule extends AttachmentModule {}

export default new SettingAttachmentModule();
